<template>
  <div class="text-xs-center">
    <v-dialog v-model="showDialog" width="500">
      <v-card>
        <v-card-title class="headline red lighten-2" primary-title>
          Error
        </v-card-title>

        <v-card-text v-for="(item, index) in errors" :key="index">
          <p>{{ item.code }}</p>
          <p>{{ item.title }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="cleanErrors"
            ref="okButton"
            autofocus
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: false
    },
    errors: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  methods: {
    cleanErrors: function() {
      this.$emit('clickedOk')
      this.$store.dispatch('cleanErrors')
    }
  },
  data() {
    return {}
  }
}
</script>
